import { render } from "./GlobalSubscriptionAlert.vue?vue&type=template&id=c35b2562&scoped=true"
import script from "./GlobalSubscriptionAlert.vue?vue&type=script&lang=js"
export * from "./GlobalSubscriptionAlert.vue?vue&type=script&lang=js"

import "./GlobalSubscriptionAlert.vue?vue&type=style&index=0&id=c35b2562&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c35b2562"]])

export default __exports__